import { BaseWebComponentTranslator } from 'apps/webcomponents/src/framework/BaseWebComponentTranslator';
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * @summary This component is used to translate node types
 * @tag gz-breach-path-graph-node-type
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-breach-path-graph-node-type')
export class BreachPathGraphNodeTypeWebComponent extends LitElement {
  /**
   * @type {number} nodeType
   */
  @property({ type: Number, attribute: true, reflect: true })
  nodeType = 20;

  constructor() {
    super();
  }

  render() {
    const nodeTypeLabel = BaseWebComponentTranslator.getInstance().getDeviceTypes(this.nodeType);

    return html`${nodeTypeLabel ?? ''}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-breach-path-graph-node-type': BreachPathGraphNodeTypeWebComponent;
  }
}
